import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { UserLogin } from '../models/user-login';
import { environment } from '../../../../environments/environment';
import { User } from '../../administration-managment/models/user';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  http = inject(HttpClient);

  login(username: string, password: string) {
    // return of({
    //   id: 1,
    //   name: 'Name',
    //   surname: 'Surname',
    //   email: 'email@email.it',
    //   role: {
    //     id: 1,
    //     description: 'ADMIN'
    //   },
    //   token: '',
    //   refreshToken: ''
    // });
    return this.http.post<UserLogin>(`${environment.urlBE}auth/login`, {username: username, password: password});
  }

  loginMicrosoft(token: string) {
    const headers = new HttpHeaders({
      'Authorization': token
    });
    return this.http.get<UserLogin>(`${environment.urlBE}auth/loginMicrosoft`, { headers });
  }

  refreshToken() {
    return this.http.post<UserLogin>(
      `${environment.urlBE}auth/refresh-token`, null,
      // {
      //   headers: new HttpHeaders({
      //     'Authorization': `Bearer ${refreshToken}`
      //   })
      // }
    );
}

  registration(user: User) {
    return this.http.post<User>(`${environment.urlBE}auth/registrazione`, user);
  }

  logout(id: string) {
    return this.http.get(`${environment.urlBE}auth/logout`, { params: { id } });
  }
}
